import React from "react";
import { Link } from "react-router-dom";
import MenuGrab from "components/MenuGrab";

import logoSm from "img/logo-sm.svg";

const Footer = props => {

  return (
    <>
      <MenuGrab mainElem={props.mainElem} focusElem={props.focusElem} appDiv={props.appDiv} />
      <nav className="topbar">
        <Link to="/"><img src={logoSm}></img></Link>
        <div className="pages">
          <Link to="/work"><h3 className={(props.state === "work") ? ("selected") : ""}>work</h3></Link>
          <Link to="/me"><h3 className={(props.state === "me") ? ("selected") : ""}>me</h3></Link>
        </div>
      </nav>
    </>
  )
}

export default Footer;